import { useRef } from 'react';
import { useInView } from 'framer-motion';
import theme from 'config/theme';
import { Link } from 'components/Link';
import { FadeText, FadeContainer } from 'components/CustomAnimations';
import AboutOathNumber from 'components/LottieElements/AboutOathNumber';
import { getPathWithRef } from 'helpers/utils';

export const AboutOath = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <div className="about-oath-container">
      <div className="about-oath-title">
        <FadeText inViewTrigger className="eyebrow-text" text="About Oath" />
        <FadeText
          inViewTrigger
          progressive
          className="h2-dtm"
          text="Oath has the issues, elections & candidates that you care about. We help you:"
        />
        <FadeText
          inViewTrigger
          delay={1.8}
          className="h4-text"
          text="Oath finds the issues, elections & candidates that you care about. Our easy-to-use platform allows donors to:"
        />
      </div>
      <div ref={sectionRef} className="about-oath-items">
        <FadeContainer className="about-oath-item" animateNow={isInView} delay={2}>
          <AboutOathNumber number={1} />
          <div className="about-oath-item-content">
            <FadeText className="h3-dtm" text="Invest smarter" />
            <FadeText
              className="h4-text"
              text="Oath makes it easy to see where your dollars matter with our Impact Score– combining the power of data analytics with top tier political expertise."
            />
            <Link href={getPathWithRef('/impact-score')} $color={theme.colors.white}>
              Learn more about Oath’s Impact Score
            </Link>
          </div>
        </FadeContainer>

        <FadeContainer className="about-oath-item" animateNow={isInView} delay={2.5}>
          <AboutOathNumber number={2} />
          <div className="about-oath-item-content">
            <FadeText className="h3-dtm" text="Stop the spam" />
            <FadeText
              className="h4-text"
              text="Oath is here to help you. Unlike other platforms, we do not sell or share donor contact information and we won’t spam you with annoying texts and emails."
            />
          </div>
        </FadeContainer>

        <FadeContainer className="about-oath-item" animateNow={isInView} delay={3}>
          <AboutOathNumber number={3} />
          <div className="about-oath-item-content">
            <FadeText className="h3-dtm" text="Drive results" />
            <FadeText
              className="h4-text"
              text="When you donate through Oath, your donation is transferred directly from you to the candidates or organizations you choose to support. Oath does not take a cut of donations through the platform."
            />
          </div>
        </FadeContainer>
      </div>
    </div>
  );
};
